module.exports = __webpack_public_path__ + "img/perfor.add9c283.jpg";